<template>
    <hts-drawer
        v-model="visible"
        color="main"
        :submit="submit"
        size="large"
        :title="$t('labels.addTrip')"
        @close="close">
        <hts-select-order v-model="dataAdd.order" />
    </hts-drawer>
</template>

<script setup lang="ts">
import { $api } from '#imports'
const emits = defineEmits(['refreshTables'])

const visible = ref(false)

const dataAdd = ref({
  order: ''
})

const open = () => {
  visible.value = true
}

const close = () => {
  visible.value = false
}

const resetFields = () => {
  dataAdd.value = {
    order: ''
  }
}

const submit = async () => {
  const api = $urlClient.trip.trip.add
  const data: any = await $api(api, { body: dataAdd.value })
  const resData = data?.data?.value
  if (resData?.success) {
    emits('refreshTables')
    process.client && $toast().success($t('labels.addSuccess'))
    close()
  }
}

defineExpose({ open })
</script>
